module.exports = __webpack_public_path__ + "assets/img/Katalog.3e0fd8c4.jpg";